import { FunctionComponent } from "react";
import { DetailedCartItem } from "../../../../../../../../context/CartContext/CartContext.api.types";
import { Icon } from "../../../../../../../Icon";
import Label from "../../../../../../../Label";
import "./MainDetail.scss";
import { displayMoney } from "../../../../../../../../utils/displayMoney";
import { displayWeight } from "../../../../../../../../utils/displayWeight";
import setColorName from "../../../../../../../../utils/setColorName";

type Props = {
  cartDetailedItem: DetailedCartItem;
  onDelete: () => void;
  onEdit: (cartDetailedItem: DetailedCartItem) => void;
  labels: LenghtLabel;
};
const MainDetail: FunctionComponent<Props> = ({
  cartDetailedItem,
  onDelete,
  onEdit,
  labels,
}) => {
  const { customization, manufacturingCost, variation, product, quantity } =
    cartDetailedItem;

  const productDetails = `${labels.cartGaugeLabel} ${variation?.gauge} ${labels.cartLenghtLabel} ${variation?.length} ${labels.unit}`;

  const colorName = setColorName(variation.color);

  const translateColor =
    variation.color === "blanco"
      ? "gold-white"
      : variation.color === "rojo"
      ? "gold-red"
      : variation.color === "amarillo"
      ? "gold-yellow"
      : "silver";

  const totalWeight =
    Number(variation?.weight.replace(",", ".") ?? 0) * (quantity ?? 0);

  return (
    <main className="main-detail__desktop">
      <div className="main-detail__desktop--header">
        <Label tag="p" variants="body1">
          Cod.
        </Label>
        <Label tag="p" variants="body1">
          Cant.
        </Label>
        <Label tag="p" variants="body1">
          Detalle
        </Label>

        <Label tag="p" variants="body1">
          Peso
        </Label>
        <Label tag="p" variants="body1">
          Hechura
        </Label>
      </div>
      <div className="main-detail__desktop--body">
        <Label tag="p" variants="body1" style={{ fontFamily: "Mont-Semibold" }}>
          {product?.sku ?? ""}
        </Label>
        <span className="main-detail__desktop--body__value">
          {quantity ?? ""}
        </span>
        <div className="main-detail__desktop--body__container">
          <span className="main-detail__desktop--body__value--semibold">
            {product.title}
          </span>
          <div className="main-detail__desktop--body__details">
            <div
              className={`main-detail__desktop--body__details--icon main-detail__desktop--body__details--icon__${translateColor}`}
            ></div>
            <span className="main-detail__desktop--body__value">
              {colorName}
            </span>
            <span className="main-detail__desktop--body__value">
              {productDetails}
            </span>
          </div>
          {customization && (
            <div className="main-detail__desktop--body__custom">
              <Label tag="p" variants="body1">
                Personalizado:
              </Label>
              <span className="main-detail__desktop--body__value--semibold">
                {customization}
              </span>
            </div>
          )}
        </div>
        <div className="main-detail__desktop--body__container">
          <span className="main-detail__desktop--body__value">
            {displayWeight(totalWeight)}
          </span>
          <span className="main-detail__desktop--body__value main-detail__desktop--body__value__underline">
            {displayWeight(variation.weight.replace(",", "."))}
          </span>
        </div>
        <div className="main-detail__desktop--body__container">
          <span className="main-detail__desktop--body__value">
            {manufacturingCost === 0
              ? "A consultar"
              : displayMoney(manufacturingCost * cartDetailedItem.quantity)}
          </span>
          <span className="main-detail__desktop--body__value main-detail__desktop--body__value__underline ">
            {manufacturingCost === 0
              ? "A consultar"
              : displayMoney(manufacturingCost) + " u"}
          </span>
        </div>
        <div
          onClick={() => onEdit(cartDetailedItem)}
          className="main-detail__desktop--body__options main-detail__desktop--body__options__edit"
        >
          <Icon
            iconName="edit-icon-squared"
            className="header__actions__action"
          />
        </div>
        <div
          onClick={onDelete}
          className="main-detail__desktop--body__options main-detail__desktop--body__options__trash"
        >
          <Icon iconName="trash_cart" />
        </div>
      </div>
      <hr className="main-detail__desktop--body__divider" />
    </main>
  );
};

export default MainDetail;
